// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".c-image-input__input{object-fit:scale-down;width:100%;height:100px}\n", "",{"version":3,"sources":["webpack://./src/components/image/image.scss"],"names":[],"mappings":"AAAA,sBACA,qBAAsB,CAEtB,UAAW,CACX,YAAa","sourcesContent":[".c-image-input__input {\r\nobject-fit: scale-down;\r\n//object-fit: cover;\r\nwidth: 100%;\r\nheight: 100px;\r\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
